import React from "react";
import { Reveal } from "./Reveal";
import { CheckCircleIcon } from "lucide-react";
const features = [{
  emoji: "🌿",
  title: "Método Paso a Paso",
  text: "Un recorrido claro para que sepas exactamente qué hacer cada día, sin sentirte perdida."
}, {
  emoji: "🧂",
  title: "Guía para Crear tu Primera Colección",
  text: "Aprende cómo estructurar una línea de productos atractiva y coherente desde el principio."
}, {
  emoji: "🎨",
  title: "Sistema para Crear tu Marca",
  text: "Descubre cómo elegir nombre, colores e identidad visual para transmitir profesionalismo."
}, {
  emoji: "📦",
  title: "Presentación y Packaging",
  text: "Aprende a hacer que tus productos tengan una imagen cuidada desde el primer vistazo."
}, {
  emoji: "🚀",
  title: "Preparación para el Lanzamiento",
  text: "Todo lo necesario para terminar la semana con una línea lista para mostrar al mundo."
}];
const receives = ["Los 6 Tomos Digitales del Kit", "Plantillas listas para completar", "Recursos visuales", "Guías de presentación", "Checklists de implementación"];
export function WhatsInside() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-256" data-mp="3luc6nz4idy7k">
      <div className="mx-auto max-w-xl" data-id="element-257" data-mp="3ltt17hw1p2af">
        <Reveal className="text-center" data-id="element-258" data-mp="3hta8zmq8pu7p">
          <h2 className="font-serif-display text-2xl font-semibold leading-snug text-[#3d2b30] sm:text-3xl" data-id="element-259" data-mp="3hubrgc9l5izg">
            📦 ¿Qué contiene el Kit?
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-[#6b565b] sm:text-base" data-id="element-260" data-mp="2p4v6fzoap4d9">
            Todo lo que necesitas para pasar de una simple idea a una línea de productos lista
            para presentar.
          </p>
        </Reveal>

        <div className="mt-8 space-y-3" data-id="element-261" data-mp="2y3gkpimqhx88">
          {features.map((f, i) => <Reveal key={f.title} delay={i * 0.04} data-id="element-262" data-mp="2aedsxhydyo00" data-mpi={i}>
              <div className="flex items-start gap-3 rounded-2xl border border-[#e7d3d8] bg-white p-5" data-id="element-263" data-mp="2ad2rvpwbrucl">
                <span className="text-2xl leading-none" data-id="element-264" data-mp="9d7l5p58imi7">{f.emoji}</span>
                <div data-id="element-265" data-mp="9cxus0ga2dbz">
                  <h3 className="font-serif-display text-base font-semibold text-[#3d2b30]" data-id="element-266" data-mp="9bd7mvwalwo5">
                    {f.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-[#6b565b]" data-id="element-267" data-mp="j429r05ydy6t">{f.text}</p>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} className="mt-10 rounded-2xl bg-[#3d2b30] p-6 text-white" data-id="element-268" data-mp="3mk9bv28pzndh">
          <h3 className="text-center font-serif-display text-lg font-semibold" data-id="element-269" data-mp="3riklbbv3rvv6">
            📥 ¿Qué recibes inmediatamente?
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-270" data-mp="bq7sej7oyx7">
            {receives.map(r => <li key={r} className="flex items-center gap-2.5 text-sm font-semibold" data-id="element-271" data-mp="5bw4i94c9bm5">
                <CheckCircleIcon className="h-5 w-5 flex-shrink-0 text-[#c98aa0]" data-id="element-272" data-mp="1bs7tbjl9th52" />
                {r}
              </li>)}
          </ul>
          <p className="mt-5 text-center text-sm italic text-[#e7c9d1]" data-id="element-273" data-mp="1goy8m4p948pf">
            Cada día avanzarás un paso más… hasta terminar la semana con una línea que ya no
            existe solo en tu imaginación.
          </p>
        </Reveal>
      </div>
    </section>;
}